const InputType = Object.freeze({
    switch: "switch",
    text: "text",
    dropDown: "dropDown",
    checkBox: "checkBox",
    radio: "radio",
    slider: "slider",
    dateTime: "dateTime",
    dataList: "dataList"
});

export default InputType;